import { useEffect, useState } from "react";
import apiClient from "../../shared/API/apiClient";
import { useReportingYear } from "../../context/ReportingYearContext";
import { useNavigate } from "react-router-dom";

const DashboardPage = () => {

    const { reportingYear, reportingYearId } = useReportingYear();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [dashboard, setDashboard] = useState(null);
    const [legalEntities, setLegalEntities] = useState([]);
    const [selectedEntity, setSelectedEntity] = useState("");

useEffect(() => {
    const loadLegalEntities = async () => {
        if (!reportingYearId) return;

        try {
            const res = await apiClient.get("/api/legal-entities-by-year", {
                params: { reporting_year_id: reportingYearId }
            });

            setLegalEntities(res.data.data || []);
        } catch {
            setLegalEntities([]);
        }
    };

    loadLegalEntities();
}, [reportingYearId]);

const loadDashboard = async () => {
    if (!reportingYearId) return;

    try {
        setLoading(true);

        const res = await apiClient.get("/api/dashboard", {
            params: {
                reporting_year_id: reportingYearId,
                legal_entity_id: selectedEntity || null
            }
        });

        setDashboard(res.data);

    } finally {
        setLoading(false);
    }
};

useEffect(() => {
    loadDashboard();
}, [
    reportingYearId,
    selectedEntity
]);
if (loading) {

    return (

        <div className="dash-loader-wrapper">

            <div className="dash-loader" />

        </div>

    );

}
    return (

        <div className="dash-page">

            <div className="dash-page-title">
                Dashboard
            </div>

            <div className="dash-page-subtitle">
                ESG & BRSR Operational Command Center
            </div>
<div className="filter-card">
    <div className="filter-group">
        <label>Reporting Year</label>

        <input
            className="filter-fields"
            value={reportingYear}
            disabled
        />
    </div>

    <div className="filter-group">
        <label>Legal Entity</label>

        <select
            className="filter-fields"
            value={selectedEntity}
            onChange={e => setSelectedEntity(e.target.value)}
        >
            <option value="">All Legal Entities</option>

            {legalEntities.map(entity => (
                <option
                    key={entity.entity_id}
                    value={entity.entity_id}
                >
                    {entity.entity_name}
                </option>
            ))}
        </select>
    </div>
</div>
<div className="reporting_year_line">
    <strong>{reportingYear}</strong>
    {selectedEntity
        ? ` | ${legalEntities.find(e => Number(e.entity_id) === Number(selectedEntity))?.entity_name}`
        : " | All Legal Entities"}
</div>
{dashboard?.summary?.length>0&&(
  <div className="dash-stat-grid" style={{gridTemplateColumns:`repeat(${dashboard.summary.length},1fr)`}}>
    {dashboard.summary.map((item,index)=>(
      <div key={index} className="dash-stat-card">
        <div className="dash-stat-header">
          <i className={`fa-solid ${item.icon} dash-stat-icon`} style={{color:item.color}}/>
          <div className="dash-stat-label">{item.title}</div>
        </div>
        <div className="dash-stat-value" style={{color:item.color}}>{item.value}</div>
      </div>
    ))}
  </div>
)}
<div className="chart-row">

<div className="chart-card">
  <div className="chart-header">
    <h4>My Work Queue</h4>
    <span>{dashboard?.action_queue?.count||0} Items</span>
  </div>

  <div className="action-queue-list">
    {(dashboard?.action_queue?.items||[]).map(item=>(
      <div key={item.submission_id} className={`action-work-card ${item.priority}`}>
        <div className="action-left">
          <div className="action-title">{item.principle_code} • {item.principle_name}</div>
          <div className="action-subtitle">{item.legal_entity_name}</div>

          <div className="action-meta">
  <span className="status-pill" style={{background:item.status.color_code,color:item.status.fore_color}}>
    <i className={`fa-solid ${item.status.icon}`}/> {item.status.name}
  </span>

  <span className="workflow-info">
    <strong>{item.last_action.label}</strong> by <strong>{item.last_action.by}</strong>
    {item.last_action.role&&<> ({item.last_action.role})</>}
  </span>

  <span><i className="fa-solid fa-clock"/> {item.sla_days}</span>
</div>
<div className="next-stage">
  <span className="next-stage-label"><i className="fa-solid fa-arrow-right"/> Next Stage</span>
  <span className="next-stage-value">{item.next_stage}</span>
</div>

          {item.attention_summary?.title && (
            <div className="attention-box">
              <div className="attention-title"><i className="fa-solid fa-circle-exclamation"/> {item.attention_summary.title}</div>
              <div className="attention-message">{item.attention_summary.message}</div>
              <div className="attention-footer">
                <span><i className="fa-solid fa-user"/> {item.attention_summary.by} ({item.attention_summary.role})</span>
                <span><i className="fa-solid fa-calendar-days"/> {item.attention_summary.date}</span>
              </div>
            </div>
          )}
          <button className="org-btn-save" onClick={()=>window.location.href=item.action.url}>{item.action.label}</button>
        </div>

       
      </div>
    ))}

    {dashboard?.action_queue?.count===0&&(
      <div className="empty-card">
        <i className="fa-solid fa-circle-check"/><br/>
       No work items require your attention.
      </div>
    )}
  </div>
</div>
<div className="chart-card">
    <div className="chart-header">
    <h4>Recently Completed</h4>
    <span>{dashboard?.recently_completed?.count||0} Items</span>
  </div>

  <div className="action-queue-list">
    {(dashboard?.recently_completed?.items||[]).map(item=>(
      <div key={item.submission_id} className="action-card low">
        <div className="action-left">
          <div className="action-title">{item.legal_entity_name}</div>
          <div className="action-subtitle">{item.principle_code} • {item.principle_name}</div>
         <div className="action-meta">
  <span className="status-pill" style={{background:item.status.color_code,color:item.status.fore_color}}>
    <i className={`fa-solid ${item.status.icon}`}/> {item.status.name}
  </span>

  <span className="workflow-info">
    <strong>Completed by</strong> <strong>{item.completed_by}</strong>
    {item.completed_role&&<> ({item.completed_role})</>}
  </span>

  <span><i className="fa-solid fa-clock"/> {item.completed_date}</span>
</div>
        </div>
        <button className="org-btn-save" onClick={()=>window.location.href=item.action.url}>{item.action.label}</button>
      </div>
    ))}

    {dashboard?.recently_completed?.count===0&&<div className="empty-state">No recently completed submissions.</div>}
  </div>
</div>
   </div> 

        </div>

    );

};

export default DashboardPage;